import VueRouter from "vue-router";

// Home section
import Home from "../components/home/Home.vue";

// About section
import Diversity from "../components/about/Diversity.vue";
import About from "../components/about/About.vue";
import People from "../components/about/People.vue";
import PeopleDetail from "../components/about/PeopleDetail.vue";
import Alumni from "../components/about/Alumni.vue";
import Robots from "../components/about/Robots.vue";
import Awards from "../components/about/Awards.vue";
import Fun from "../components/about/Fun.vue";

// Research section
import Research from "../components/research/Research.vue";
import ProjectPage from "../components/research/ProjectPage.vue";
import Areas from "../components/research/Areas.vue";
import Domains from "../components/research/Domains.vue";
import Projects from "../components/research/Projects.vue";
import Resources from "../components/research/Resources.vue";
import Publications from "../components/research/Publications.vue";
import Sponsors from "../components/research/Sponsors.vue";

// Outreach section
import Outreach from "../components/outreach/Outreach.vue";

// Media section
import Media from "../components/media/Media.vue";
import MediaCoverage from "../components/media/MediaCoverage.vue";
import Videos from "../components/media/Videos.vue";

// Contact section
import Contact from "../components/contact/Contact.vue";

// Common skills section

import Common_skills from "../components/common_skills/Common_skills.vue";

// Edit Home section
import EditHome from "../edit_components/home/EditHome.vue";

// Edit About section
import EditPeople from "../edit_components/about/EditPeople.vue";
import EditRobots from "../edit_components/about/EditRobots.vue";
import EditAwards from "../edit_components/about/EditAwards.vue";
import EditFun from "../edit_components/about/EditFun.vue";

// Research section
import EditAreas from "../edit_components/research/EditAreas.vue";
import EditDomains from "../edit_components/research/EditDomains.vue";
import EditProjects from "../edit_components/research/EditProjects.vue";
import EditPublications from "../edit_components/research/EditPublications.vue";
import EditSponsors from "../edit_components/research/EditSponsors.vue";

// Description page
import Description from "../components/utils/Description.vue";

// PhD Timeline page
import Timeline from "../components/utils/Timeline.vue"

// Edit Outreach section
import EditOutreach from "../edit_components/outreach/EditOutreach.vue";

// Edit Media section
import EditMediaCoverage from "../edit_components/media/EditMediaCoverage.vue";
import EditVideos from "../edit_components/media/EditVideos.vue";

// Edit Contact section
import EditContact from "../edit_components/contact/EditContact.vue";

// Signin section
// import Signin from "../components/auth/Signin.vue";

// Vuex store
import store from "../store/index";

// firebase
import { app } from "../utils/firebase";

const routes = [
  { path: "/", component: Home, name: "Home" },
  // { path: "/signin", component: Signin },
  { path: "/quit", redirect: "/home", name: "Quit Edit" },
  { path: "/home/edit", component: EditHome, name: "Edit Home" },
  { path: "/timeline", component: Timeline, name: "Timeline" },
  {
    path: "/about",
    component: About,
    children: [
      {
        path: "diversity_equity_inclusion",
        component: Diversity,
        name: "Lab Family Culture"
      },
      {
        path: "people",
        component: People,
        name: "People",
      },
      {
        path: "people/desc",
        component: PeopleDetail,
        name: "PeopleDetail",
      },
      {
        path: "people/alumni",
        component: Alumni,
        name: "Alumni",
      },
      {
        path: "people/graduation",
        component: Description,
        name: "Graduation",
      },
      {
        path: "robots",
        component: Robots,
        name: "Robots",
      },
      {
        path: "awards",
        component: Awards,
        name: "Awards",
      },
      {
        path: "fun",
        component: Fun,
        name: "Fun",
      },
      {
        path: "fun/description",
        component: Description,
        name: "Fun Description",
      },
      {
        path: "people/edit",
        component: EditPeople,
        name: "Edit People",
      },
      {
        path: "robots/edit",
        component: EditRobots,
        name: "Edit Robots",
      },
      {
        path: "awards/edit",
        component: EditAwards,
        name: "Edit Awards",
      },
      {
        path: "fun/edit",
        component: EditFun,
        name: "Edit Fun",
      },
    ],
  },
  {
    path: "/research",
    component: Research,
    children: [
      {
        path: "areas",
        component: Areas,
        name: "Areas",
      },

      {
        path: "domains",
        component: Domains,
        name: "Domains",
      },

      {
        path: "projects",
        component: Projects,
        name: "Projects",
      },
      {
        path: "resources",
        component: Resources,
        name: "Resources"
      },
      {
        path: "publications",
        component: Publications,
        name: "Publications",
      },
      {
        path: "sponsors",
        component: Sponsors,
        name: "Sponsors",
      },
      {
        path: "areas/edit",
        component: EditAreas,
        name: "Edit Areas",
      },
      {
        path: "domains/edit",
        component: EditDomains,
        name: "Edit Domains",
      },
      {
        path: "projects/edit",
        component: EditProjects,
        name: "Edit Projects",
      },
      {
        path: "publications/edit",
        component: EditPublications,
        name: "Edit Publications",
      },
      {
        path: "sponsors/edit",
        component: EditSponsors,
        name: "Edit Sponsors",
      },
    ],
  },
  { path: "/project", component: ProjectPage, name: "project page redirect" },
  { path: "/project/:id", component: ProjectPage, name: "project page" },
  { path: "/outreach", component: Outreach, name: "Outreach" },
  {
    path: "/outreach/description",
    component: Description,
    name: "Outreach Description",
  },
  { path: "/outreach/edit", component: EditOutreach, name: "Edit Outreach" },
  {
    path: "/media",
    component: Media,
    children: [
      {
        path: "media-coverage",
        component: MediaCoverage,
        name: "Media Coverage",
      },
      // Redirect old space-based URLs (e.g. bookmarks) to the new path
      { path: "media%20coverage", redirect: { name: "Media Coverage" } },
      {
        path: "media%20coverage/edit",
        redirect: { name: "Edit Media Coverage" },
      },
      {
        path: "videos",
        component: Videos,
        name: "Videos",
      },
      {
        path: "media-coverage/edit",
        component: EditMediaCoverage,
        name: "Edit Media Coverage",
      },
      {
        path: "videos/edit",
        component: EditVideos,
        name: "Edit Videos",
      },
    ],
  },
  { path: "/contact", component: Contact, name: "Contact" },
  { path: "/common_skills", component: Common_skills, name: "Common_skills" },
  { path: "/contact/edit", component: EditContact, name: "Edit Contact" },
];

const router = new VueRouter({
  routes,
  mode: "history",
});

/**
 * router guard
 * prevent unauthenticated user to access edit page
 */
router.beforeEach((to, from, next) => {
  if (to.path.indexOf("/edit") !== -1) {
    if (app.auth().currentUser) {
      store.state.isEdit = true;
      localStorage.isEdit = true;
      next();
    } else next("/signin");
  } else {
    next();
  }
});

export default router;
